// models
import dayjs from 'dayjs';
import type {
  ReqSafetyDetailProps,
  CreateSafetyProps,
  SafetyDetailProps,
  SafetyAttendanceProps
} from '../model/safety.model';

// libraries
import { atom } from 'recoil';

export type SafetyDetailFormType = SafetyDetailProps & CreateSafetyProps;

export const SafetyDetailFormAtom = atom<SafetyDetailFormType>({
  key: 'SafetyDetailFormAtom',
  default: {
    safetyId: '',
    categoryId: '',
    categoryName: '',
    trainingId: '',
    trainingName: '',
    trainerId: '',
    trainerName: '',
    trainingDate: dayjs().format('YYYY-MM-DD'),
    contents: '',
    status: '',
    fileId: undefined,
    fileUrl: undefined,
    file: undefined
  }
});

export const SafetyDetailSearchAtom = atom<ReqSafetyDetailProps>({
  key: 'SafetyDetailSearchAtom',
  default: {
    safetyId: '',
    keyword: ''
  }
});

export const SafetyAttendanceListAtom = atom<SafetyAttendanceProps[]>({
  key: 'SafetyAttendanceListAtom',
  default: []
});
